'use client';

import { forwardRef } from '@ironhack/design-system2/components/forward-ref';
import { Text } from '@ironhack/design-system2/components/text';
import { type As, type ComponentWithAs } from '@ironhack/design-system2/types';

import { ModuleWrapper } from '@/app/components/server/module-wrapper';

type Props = {
  cardsTitle: string;
  // Needed for use with NavigationTabs
  title?: string;
};

export const Cards: ComponentWithAs<As, Props> = forwardRef(
  (props: Props, ref) => {
    const { cardsTitle } = props;

    return (
      <ModuleWrapper
        innerProps={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
        moduleFormat={{
          background: 'light',
          spacingBottom: '40',
          spacingTop: '40',
        }}
        ref={ref}
      >
        <Text as="h2" textStyle="4xl">
          {cardsTitle}
        </Text>
      </ModuleWrapper>
    );
  }
);
